import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, browserLocalPersistence, setPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDfoleOZTznCyPY1LpYDncmHDxjneoajaM",
  authDomain: "hometrak-48e52.firebaseapp.com",
  projectId: "hometrak-48e52",
  storageBucket: "hometrak-48e52.firebasestorage.app",
  messagingSenderId: "116664280262",
  appId: "1:116664280262:web:9e2615ffb5fe1acb92e3c7",
  measurementId: "G-XJ0QJ99VCG"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);

// Set persistence to LOCAL so Safari doesn't lose auth state during redirects
setPersistence(auth, browserLocalPersistence);